import Pillars from './Pillars';

export default Pillars;
